module.exports = __webpack_public_path__ + "static/media/bevege.730aa91e.m4a";